import { CallRoute, CallRouteType } from '@weave/schema-gen-ts/dist/schemas/phone/callroute/v1/callroute_service.pb';
import { ExtendedCallRoute } from '../types';

/**
 * Filters an array of `CallRoute` or `ExtendedCallRoute` objects to return only those
 * that are considered true call routes.
 *
 * This function identifies call routes by checking if the `callRouteType` is either
 * `CALL_ROUTE_TYPE_CALL_ROUTE` or `CALL_ROUTE_TYPE_DEPARTMENT`, as departments are
 * treated as a type of call route in this context.
 *
 * @template T - The type of the route objects, which must extend `CallRoute` or `ExtendedCallRoute`.
 * @param routes - The optional array of routes to filter.
 * @returns A new array containing only the call routes. Returns an empty array if the input is `undefined` or `null`.
 */
export const filterCallRoutesOnly = <T extends CallRoute | ExtendedCallRoute>(routes?: T[]): T[] => {
  return (
    routes?.filter(
      (route) =>
        route.callRouteType === CallRouteType.CALL_ROUTE_TYPE_CALL_ROUTE ||
        route.callRouteType === CallRouteType.CALL_ROUTE_TYPE_DEPARTMENT // Departments are a type of Call Route
    ) ?? []
  );
};
